// extracted by mini-css-extract-plugin
export var quotationEnd = "index-module--quotation-end--26ece";